
const $ = require('jquery')

import * as log from 'loglevel'



Array.prototype.unique = function(){
    return this.filter(
	function(a){return !this[a] ? this[a] = true : false;}, {}
    );
}

const u = {};

u.localP = function (){
    var localP = window.location.host.match("localhost")
    log.debug("localP",localP)
    if (localP){
	return true
    } else {
	return false
    }
}
	      	

u.ajaxError = function (URL,
			jqXHR,
			textStatus,
			errorThrown,
			data,
			callback) {
    log.error("ERROR lobe.Ajax", {jqXHR: jqXHR,
				    textStatus: textStatus,
				    errorThrown: errorThrown,
				    url: URL,
				    data: JSON.stringify(data),
				    callback: JSON.stringify(callback)});
    alert("Internal error - please request help from graphMetrix admin (or see developer console)." +
	  "\nError: " + errorThrown +
	  "\nStatus: " + textStatus +
	  "\nURL: " + URL);
}


u.ajax = function (URL, callback, Type, dataType, data, cache, Asyn) {
    var Async
    if (!Type) {
        Type = "POST";
    }
    if (!cache){
	cache = false;
    }
    if (!dataType) {
	dataType = "json";
    }
    if (typeof (Asyn) === "boolean") {
        Async = Asyn;
    } else {
	Async = true;
    }
    $.ajaxSetup({
        async: Async
    });
    $.ajax({
        type: Type,
        url: URL,
        data: data,
        async: Async,
        cache: cache,
        success: function (Data) {
	    callback(Data);
        },
        error: function(jqXHR, textStatus, errorThrown){
	    u.ajaxError(URL, jqXHR, textStatus, errorThrown, data,callback);
	},
        dataType: dataType
    });
}

u.getURL = function (string) {
    if ($.type(string) === "object"){
	return string.uri;
    } else if ($.type(string) === "string"){
	if (u.checkURL(string)){
	    return string;
	} else if (u.checkIRI(string)){
	    return string.substr(1,string.length - 2);
	} else {
	    return null;
	}
    }
}

u.getURI = function (string) {
    return u.getURL(string);
}

u.getURIs = function (array) {
    if ($.type(array) === "array"){
	return $.map(array,function(item){
	    return u.getURI(item);
	});
    }
}

u.getIRI = function (string) {
    if (u.checkIRI(string)){
	return string;
    } else if (u.checkURL(string)){
	if (string.indexOf("?") > -1){
	    string = string.split("?")[0];
	}
	return "<" + string + ">";
    } else {
	return null;
    }
}

u.checkIRI = function (string) {
    if ($.type(string) === "string"){
	if (string.indexOf("<http") == 0 && string.indexOf(">") > -1 && string.indexOf("?") == -1){
	    return true;
	} else {
	    return false;
	}
    } else {
	return false;
    }
}

u.checkURL = function (string) {
    if ($.type(string) === "string"){
	if (/^(https?|ftp):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!\$&'\(\)\*\+,;=]|:)+))\])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(string)) {
	    return true;
	} else {
	    return false;
	}
    } else {
	return false;
    }
}

u.checkEmail = function (email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

u.deparam = function (querystring) {
    // remove any preceding url and split
    //danger: this function takes time and cannot return synchronous when using window
    if (!querystring) {
        querystring = window.location.href;
    }
    querystring = querystring.substring(querystring.indexOf('?') + 1).split('&');
    var params = {}, pair, d = decodeURIComponent;
    // march and parse
    for (var i = querystring.length - 1; i >= 0; i--) {
        pair = querystring[i].split('=');
        params[d(pair[0])] = d(pair[1] || '');
    }

    return params;
}

u.getEObj = function (qObj) {
    return JSON.parse(JSON.stringify(qObj))
}

u.deleteKeys = function (qObj, keys) {
    //if keys is null, uses all keys in qObj
    if (qObj) {
        var eObj = u.getEObj(qObj)
        if (keys) {
            if ($.type(keys) !== "array") {
                keys = [keys]
            }
        } else {
            keys = Object.keys(eObj)
        }
        $.map(keys, function (key) {
            delete eObj[key]
        })
        return eObj
    }
}

u.addQuery = function (key, value, qObj) {
    if (key && value/* && qObj*/) {
        if (!qObj) {
            qObj = u.deparam()
        }
        var eObj = u.getEObj(qObj)
        eObj[key] = value
        return eObj
    }
}

export default u
